import { render, staticRenderFns } from "./SvgLogoMobile.vue?vue&type=template&id=2e85d5f3&"
import script from "./SvgLogoMobile.vue?vue&type=script&lang=js&"
export * from "./SvgLogoMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports